import React, { useState, useCallback, memo } from 'react';

const PlayButton: React.FC = memo(() => {
  const [isPressed, setIsPressed] = useState(false);

  const handleClick = useCallback(() => {
    // Placeholder for video functionality
    console.log('Play button clicked - video functionality would be implemented here');
    
    // Visual feedback
    setIsPressed(true);
    setTimeout(() => {
      setIsPressed(false);
    }, 150);
  }, []);

  const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  }, [handleClick]);

  return (
    <div 
      className={`play-overlay ${isPressed ? 'pressed' : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="button"
      aria-label="הפעל וידאו"
      style={{
        transform: isPressed 
          ? 'translate(-50%, -50%) scale(0.95)' 
          : 'translate(-50%, -50%) scale(1)'
      }}
    >
      <svg 
        className="play-icon" 
        width="80" 
        height="80" 
        viewBox="0 0 24 24" 
        fill="white"
        aria-hidden="true"
      >
        <polygon points="5,3 19,12 5,21"></polygon>
      </svg>
    </div>
  );
});

PlayButton.displayName = 'PlayButton';

export default PlayButton;